import { Routes } from '@angular/router';
import { DashboardComponent } from '@app/app-components';
import {
  RenderInterfaceGuard
} from 'viggo-sistemas-core-web';

export const routesWorkspace: Routes = [
  {
    path: 'workspace',
    canActivate: [RenderInterfaceGuard], // SE N FOR USAR O BREADCRUMB COM CAMINHOS PRO MENU TROCAR ISSO PRO AUTHGUARD
    component: DashboardComponent,
    data: {
      breadcrumb: {
        label: 'Dashboard',
        icon: 'pi pi-fw pi-chart-bar'
      }
    }
  }
];
